<template>
<div class="centered-container">
    <md-content class="set-instance">
      <div class="title">
        <div
          class="md-body-2"
        >To connect to the Harmony PSA application, please provide the URL you would normally use to log in.</div>
        <br>
        <div class="md-body-1" style="color: grey">Example: mycompany.harmonypsa.com</div>
      </div>

      <div class="form">
        <md-field>
          <label>Harmony URL</label>
          <md-input v-model="login.site" type="url" autofocus></md-input>
        </md-field>
      </div>

      <div class="actions md-layout md-alignment-center">
        <md-button class="md-raised md-primary" @click="goToSite">Continue</md-button>
      </div>

      <div class="loading-overlay" v-if="loading">
        <md-progress-spinner md-mode="indeterminate" :md-stroke="2"></md-progress-spinner>
      </div>
    </md-content>
  </div>
</template>

<script>
var isGoNative = navigator.userAgent.indexOf("gonative") > -1;
import axios from 'axios';

if(isGoNative) {
  setTimeout(function() {
    var items = [
      {
        label: 'Help guide',
        url: 'javascript:window.open("https://help.harmonypsa.com/")',
        subLinks: [],
        icon: 'fa-question-circle'
      }
    ]

    var json = JSON.stringify(items)

    window.location.href =
      'gonative://sidebar/setItems?items=' + encodeURIComponent(json)
  }, 0)
}

export default {
  data() {
    return {
      loading: false,
      login: {
        site: ''
      }
    }
  },
  methods: {
    goToSite() {
      // Show the loading spinner
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 30000)

      // Remove prefixes
      var url = this.login.site
        .toLowerCase()
        .replace("https://", "")
        .replace("http://", "")
        .trim();

      // Remove routes and format
      if(url.indexOf('/') > -1){
        url = url.substring(0, url.indexOf('/'));
      }

      if(url.indexOf('.') == -1){
        url = url + ".harmonypsa.com";
      }

      this
        .canGoToSite(url)
        .then(response => (response ? this.redirect(url) : this.showError(url)));
    },
    async canGoToSite(url) {
      try {
        var request = axios.get("https://" + url + "/security/getinstanceinformation");
      } catch {
        return false;
      }

      var canGoToSite = request.then(response => {
        var versionString = response.data.Version;
          if(!versionString) return false;

          var version = versionString.split('.');

          // Ensure version is at least 4.20.x
          if(version[0] > 4) return true;
          if(version[0] < 4) return false;
          if(version[1] < 20) return false;

          return true;
      }).catch(() => {
        return false;
      });

      return canGoToSite;
    },
    redirect(url) {
      // Add the HTTPS prefix back
      url = 'https://' + url
  
      // Set the site as the initial URL
      if(isGoNative)
        window.location.href = 'gonative://config/set?initialUrl=' + url

      // Go to the site after a short wait, to allow the goNative call to go through.
      setTimeout(function() {
        window.location.href = url
      }, 3000)
    },
    showError(url) {
        // (Better) validation stuff goes here
        alert("This URL is not for Harmony PSA site, or the site is not yet ready for mobile: " + url + ". If the URL is correct, your Harmony version may need to be upgraded to 4.20. Please contact your administrator to request an upgrade.")
        this.loading = false;
        return;
    }
  },
  mounted() {
    var self = this;
    window.addEventListener('keyup', function(event) {
      if (event.keyCode === 13) {
        self.goToSite();
      }
    });
  }
}
</script>

<style lang="scss">
.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: -webkit-fill-available;
  background: #ebeff0;

  .title {
    text-align: center;
    margin-bottom: 30px;
    img {
      margin-bottom: 16px;
      max-width: 160px;
    }
  }
  .actions {
    .md-button {
      margin: 0;
    }
  }
  .form {
    margin-bottom: 60px;
  }
  .md-content {
    z-index: 1;
    padding: 40px;
    width: 80%;
    max-width: 400px;
    position: relative;
    min-height: -webkit-fill-available;
    border-radius: 20px;
  }
  .loading-overlay {
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
